import actions from "./actions";
import {
  FETCH_MAIL_PIECES_DETAILED_COUNT,
  FETCH_MAIL_PIECES_TOTAL,
  RESET_DASHBOARD,
  SET_DATES,
  SET_TEMPLATE_FILTER,
  SET_QUICK_FILTER,
  FILTER_TEMPLATES
} from "./types";
import {
  errorMutations,
  loadingMutations,
  resetErrorsAndLoading,
  setter,
  getter
} from "@/store/utils";

import { formatMailPieceChartData } from "@/utils/util";

const getInitialState = () => ({
  isLoading: false,
  isLoadingInitial: false,
  errors: null,
  start_date: null,
  end_date: null,
  total: null,
  items: [],
  total_cost: null,
  filteredPostcardSizes: ["all"],
  filteredLetterSizes: ["all"],
  filteredPostcardNames: ["initial"],
  filteredLetterNames: ["initial"],
  filteredTemplates: [],
  quickFilter: "1W"
});

const state = getInitialState();

const getters = {
  isLoading: getter("isLoading"),
  isLoadingInitial: getter("isLoadingInitial"),
  errors: getter("errors"),
  items: getter("items"),
  total: getter("total"),
  start_date: getter("start_date"),
  end_date: getter("end_date"),
  total_cost: getter("total_cost"),
  filteredNames: state => [
    ...state.filteredPostcardNames,
    ...state.filteredLetterNames
  ],
  filteredSizes: state => [
    ...state.filteredPostcardSizes,
    ...state.filteredLetterSizes
  ],
  filteredPostcardSizes: getter("filteredPostcardSizes"),
  quickFilter: getter("quickFilter"),
  filteredTemplates: getter("filteredTemplates"),
  filteredLetterSizes: getter("filteredLetterSizes")
};

const mutations = {
  [SET_DATES](state, { payload }) {
    setter("start_date", payload.start)(state);
    setter("end_date", payload.end)(state);
  },

  [SET_TEMPLATE_FILTER](state, { payload }) {
    if (
      payload.filterType === "size" &&
      payload.templateType === "all" &&
      payload.value &&
      !payload.value.length
    ) {
      setter("filteredLetterSizes", payload.value)(state);
      setter("filteredPostcardSizes", payload.value)(state);
    } else {
      // determine if it's name or size update
      // and which template type being updated
      const stateKeyToUpdate =
        payload.filterType === "size"
          ? payload.templateType === "letter"
            ? "filteredLetterSizes"
            : "filteredPostcardSizes"
          : payload.templateType === "letter"
          ? "filteredLetterNames"
          : "filteredPostcardNames";
      setter(stateKeyToUpdate, payload.value)(state);
    }
  },

  [FETCH_MAIL_PIECES_DETAILED_COUNT.request](state, { payload }) {
    if (payload.initial) {
      setter("isLoadingInitial", true)(state);
    } else {
      setter("isLoading", true)(state);
    }
  },

  [SET_QUICK_FILTER](state, { payload }) {
    setter("quickFilter", payload)(state);
  },

  [FILTER_TEMPLATES.success](state, { payload }) {
    setter("filteredTemplates", payload.items)(state);
    resetErrorsAndLoading(state);
  },

  [FETCH_MAIL_PIECES_DETAILED_COUNT.success](state, { payload }) {
    const {
      data: { items, start_date, end_date, total, total_cost },
      initial
    } = payload;

    setter(
      "items",
      formatMailPieceChartData(items, start_date, end_date)
    )(state);

    setter("start_date", start_date)(state);
    setter("end_date", end_date)(state);
    setter("total", total)(state);
    setter("total_cost", total_cost)(state);
    resetErrorsAndLoading(state);

    if (initial) {
      setter("isLoadingInitial", false)(state);
    }
  },

  [FETCH_MAIL_PIECES_TOTAL.success](state, { payload }) {
    setter("total", payload.total)(state);
    setter("total_cost", payload.total_cost)(state);
    resetErrorsAndLoading(state);
  },

  [RESET_DASHBOARD](state) {
    const initialState = getInitialState();
    for (let obj of Object.keys(initialState)) {
      setter(obj, initialState[obj])(state);
    }
  },

  ...loadingMutations([
    FETCH_MAIL_PIECES_TOTAL.request,
    FILTER_TEMPLATES.request
  ]),
  ...errorMutations([
    FETCH_MAIL_PIECES_DETAILED_COUNT.error,
    FETCH_MAIL_PIECES_TOTAL.error
  ])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
